import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Grid from "../../../components/grid";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import {
  INT_TIPO_USUARIO_ADMINISTRADOR_WEB,
} from "../../../utils/const/int-const";
import cargandoCard from "../../../components/cargando-card";
import SinAccesoCard from "../../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { sharedNextPage } from "../../../utils/shared-functions";
import { deshabilitarPieDePagina, guardarPieDePagina, obtenerListaPieDePagina } from "../../../api/api-pie-de-pagina";
import ModalPieDePagina from "../../../components/modal-pie-de-pagina";
import { useTranslation } from "react-i18next";
import { STRING_COLOR_PRIMARIO, STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST, STRING_TIPO_USUARIO_CHECKLIST } from "../../../utils/const/string-const";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { obtenerPermisos } from "../../../api/api-permisos";
import { PAGE_ID } from "../../../utils/const/pages-const";

const idTipoUsuario = localStorage.getItem(STRING_TIPO_USUARIO_CHECKLIST);
const idSubTipoUsuarioWeb = localStorage.getItem(STRING_ID_SUB_TIPO_USUARIO_WEB_CHECKLIST);


export default function ListarPieDePagina() {
  const { t } = useTranslation();
  const headers = [
    { key: "acciones", title: t('column_acciones') },
    { key: "id", title: "ID", visible: false, },
    { key: "idTipoChecklist", title: "ID TIPO CHECKLIST", visible: false, filter: true, editLabel: true, },
    { key: "tipoChecklist", title: t('column_tipo_checklist'), visible: true, filter: true, },
    { key: "nota", title: t('column_nota'), visible: true, filter: true, },
    { key: "fechaProceso", title: t('column_fecha_proceso'), visible: true, filter: true },
  ];
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [listaOpcionesRespuesta, setListaOpcionesRespuesta] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalPieDePaginaVisible, setModalPieDePaginaVisible] = useState(false);
  const [formData, setFormData] = useState({});
  const [formularioSelected, setFormularioSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [colorMain, setColorMain] = useState(COLOR_AZUL_MAIN);

  const [btnNuevo, setBtnNuevo] = useState(false);

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      setCargandoPage(true);
      const colorBase = localStorage.getItem(STRING_COLOR_PRIMARIO);
      if (colorBase !== null) {
        setColorMain(colorBase);
      }
      let permiso = null;
      let lista = [];
      lista = await obtenerListaPieDePagina();
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(true);
        setTieneAccesoAlModulo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        const objEnviar = {
          idSubTipoUsuarioWeb: idSubTipoUsuarioWeb,
        };
        const permisos = await obtenerPermisos(objEnviar);
        if (permisos.error === false && Array.isArray(permisos.data) && permisos.data.length > 0) {
          permiso = permisos.data[0];
          const permisosInfo = JSON.parse(permisos.data[0].permisos);
          // console.log('permisosInfo');
          // console.log(permisosInfo);
          const permisosPage = permisosInfo.find(e => e.value === PAGE_ID.GESTIONAR_PIE_DE_PAGINA);
          // console.log('permisosPage');
          // console.log(permisosPage);
          setTieneAccesoAlModulo(permisosPage.checked === true);
        }
      }
      agregarAccionesALista(lista, permiso);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const agregarAccionesALista = (lista, permiso) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);
      if (lista.length === 0) {
        setListaOpcionesRespuesta(lista);
        return;
      }
      const objFormulario = {
        label: t('btn_formulario'),
        color: "blue",
        onClick: (param) => formularioPieDePagina(param),
      };
      const objDeshabilitar = {
        label: t('btn_deshabilitar'),
        color: "red",
        onClick: (param) => cambiarEstado(param),
      };
      let btnFormulario = false;
      let btnDeshabilitar = false;
      let btnNuevo = false;
      if (permiso !== null) {
        const parsePermisos = JSON.parse(permiso.permisos);
        const permisosPieDePagina = parsePermisos.find(e => e.value === PAGE_ID.GESTIONAR_PIE_DE_PAGINA);
        if (permisosPieDePagina !== undefined) {
          const acciones = permisosPieDePagina.acciones;
          if (acciones !== undefined) {
            const formulario = acciones.find(e => e.value === 'btn_formulario');
            if (formulario !== undefined) {
              btnFormulario = formulario.checked;
            }
            const deshabilitar = acciones.find(e => e.value === 'btn_deshabilitar');
            if (deshabilitar !== undefined) {
              btnDeshabilitar = deshabilitar.checked;
            }
            const nuevo = acciones.find(e => e.value === 'btn_nuevo');
            if (nuevo !== undefined) {
              btnNuevo = nuevo.checked;
            }
          }
        }
      }
      if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(true);
      }
      if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
        setBtnNuevo(btnNuevo);
      }
      for (let i = 0; i < lista.length; i++) {
        let acciones = [];
        if (String(idTipoUsuario) === String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          acciones.push(objFormulario);
          acciones.push(objDeshabilitar);
        }
        if (String(idTipoUsuario) !== String(INT_TIPO_USUARIO_ADMINISTRADOR_WEB)) {
          if (btnFormulario === true) {
            acciones.push(objFormulario);
          }
          if (btnDeshabilitar === true) {
            acciones.push(objDeshabilitar);
          }
        }
        lista[i].acciones = acciones;
      }
      setListaOpcionesRespuesta(lista);

    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const formularioPieDePagina = (data) => {
    try {
      // console.log("formularioPieDePagina");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t('titulo_modificar_formulario_pie_de_pagina');
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("pie-de-pagina", obj, history);
    } catch (err) {
      console.log("formularioPieDePagina err");
      console.log(err);
    }
  };

  const cambiarEstado = async (data) => {
    try {
      console.log("cambiarEstado");
      console.log(data);
      setFormularioSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("cambiarEstado err");
      console.log(err);
    }
  };

  const handleNuevoPieDePaginaClick = () => {
    // console.log("handleNuevoPieDePaginaClick");
    setFormData({
      ...formData,
      nota: "",
    });
    setModalPieDePaginaVisible(true);
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleConfirmModal = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (formularioSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formularioSelected.id;
    if (formularioSelected.id !== 0) {
      // console.log('crear correo');
      const deshabilitado = await deshabilitarPieDePagina(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (deshabilitado === true) {
        alert(t('alert_se_deshabilito_correctamente'));
        reset();
      }
      if (deshabilitado === false) {
        alert(t('alert_no_se_pudo_deshabilitar'));
      }
    }
  };

  const onConfirmNuevoPieDePagina = async () => {
    setModalPieDePaginaVisible(false);
    // console.log("onConfirmNuevoPieDePagina");
    // console.log(formData);
    const resp = await guardarPieDePagina(formData);
    // console.log("resp");
    // console.log(resp);
    if (resp.error === false) {
      alert(t('alert_se_creo_correctamente'));
      iniciar();
    }
    if (resp.error === true) {
      alert(t('alert_no_se_pudo_crear') + "\n" + resp.message);
    }
  }

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return SinAccesoCard();
      }
      return (
        <div>
          <div
            style={{
              paddingTop: 16,
              paddingLeft: 16,
              paddingRight: 16,
              display: 'flex',
              justifyContent: 'space-between'
            }}
          >
            <label
              style={{
                paddingLeft: 10,
                fontWeight: 'bold',
              }}
            >
              {t('titulo_gestionar_pie_de_pagina')}
            </label>
            <div className="flex justify-center">
              {btnNuevo === true && (
                <button
                  type="button"
                  className={ESTILO_BOTON_LISTAR_NUEVO}
                  onClick={handleNuevoPieDePaginaClick}
                  style={{
                    backgroundColor: colorMain,
                  }}
                >
                  {t('btn_nuevo')}
                </button>
              )}
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                {t('btn_atras')}
              </button>
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button> */}
            </div>
          </div>
          <Grid rows={listaOpcionesRespuesta} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModal}
            message={t('alert_esta_seguro_de_deshabilitar_formulario')}
          />
          <ModalPieDePagina
            isOpen={modalPieDePaginaVisible}
            onCancel={() => { setModalPieDePaginaVisible(false); }}
            formData={formData}
            setFormData={setFormData}
            onConfirm={onConfirmNuevoPieDePagina}
            title={t('titulo_nuevo_pie_de_pagina')}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarPieDePagina render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
